var map = {
	"./jpeg-optimizer_IMG_9937.jpg": 2786,
	"./jpeg-optimizer_IMG_9938.jpg": 555,
	"./jpeg-optimizer_IMG_9939.jpg": 9927,
	"./jpeg-optimizer_IMG_9941.jpg": 9150,
	"./jpeg-optimizer_IMG_9942.jpg": 2649,
	"./jpeg-optimizer_IMG_9943.jpg": 7317,
	"./jpeg-optimizer_IMG_9945.jpg": 4307,
	"./jpeg-optimizer_IMG_9946.jpg": 5271,
	"./jpeg-optimizer_IMG_9949.jpg": 9691,
	"./jpeg-optimizer_IMG_9950.jpg": 1600,
	"./jpeg-optimizer_IMG_9951.jpg": 3019,
	"./jpeg-optimizer_IMG_9953.jpg": 7383,
	"./jpeg-optimizer_IMG_9954.jpg": 5969,
	"./jpeg-optimizer_IMG_9955.jpg": 6727,
	"./jpeg-optimizer_IMG_9956.jpg": 4597,
	"./jpeg-optimizer_IMG_9957.jpg": 8937,
	"./jpeg-optimizer_IMG_9958.jpg": 1086,
	"./jpeg-optimizer_IMG_9959.jpg": 483,
	"./jpeg-optimizer_IMG_9960.jpg": 2498,
	"./jpeg-optimizer_IMG_9961.jpg": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3120;